<template>
  <div class="templalteIntro">

    <Head></Head>
    <div class="template-content" v-if="animationLoading && templateData">
      <div class="animation">

        <img v-if="templateData.mainImage" class="img flip-image"
          :src="require(`@img/template/${$utils.getKmIdValueFromUrl(templateData, 'mainImage')}`)" alt="" />
        <div class="title title_1 "
          v-html="$utils.getKmIdValueFromUrl(templateData.languageConfig[$language], 'mainTitle')"></div>
        <div class="sub-title text_3 tl" :style="templateData.bgColor ? 'background-color:' + templateData.bgColor : ''"
          :class="{ 'sub-title-padding': templateData.bgColor }"
          v-html="$utils.getKmIdValueFromUrl(templateData.languageConfig[$language], 'richText')"></div>
      </div>
    </div>
    <div class="btn-warp" v-show="animationLoading && templateData">

      <div @click.once="contimueClick(), setOptionClickAnimation(-1)" class="button active text_1"
        :class="{ 'shrink-grow-effect': activeIndex === -1 }"
        v-html="templateData.languageConfig[$language].buttonText"></div>
    </div>
  </div>
</template>
<script>
import Head from "./components/head.vue"
import mixinTemplate from "@/mixin";
export default {
  name: "templalteIntro",
  mixins: [mixinTemplate],
  components: {
    Head,
  },
};
</script>
<style scoped lang="scss">
.on-body .template .title {
  margin-top: 0;
}

.templalteIntro {
  .sub-title {
    line-height: 25px;
  }

  .img {
    margin: 10px auto;
    margin-top: 32px;
    width: 100%;
    border-radius: 8px;
  }


  .sub-title-padding {
    padding: 16px 20px;
    border-radius: 16px;
  }

}
</style>
